import React from 'react'
import utils from './utils'
import parser from '../../../../services/parser.services'

function getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer) {

    const commutative = settings.commutative
    const width = gameContainerWidth
    const height = gameContainerHeight
    let { value_1, value_2 } = quantities
    const colWidth = commutative ? width / 16 : width / 8
    const fontSize = colWidth
    const answerPosition = settings.answer_position && settings.answer_position === 'left' ? 'left' : 'right'
    let numbersLayout = null
    if (commutative) {
        numbersLayout = (
            <g>
                {settings.answer_required !== 'value_1' || (settings.answer_required === 'value_1' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'value_1' ? answer : value_1}</text> :
                    utils.getOperationSign(
                        colWidth,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {quantities.value_2 && !isNaN(quantities.value_2) ? utils.getOperationSign(
                    colWidth * 2.5,
                    height / 2,
                    fontSize,
                    settings.operation === 'addition' ? 'plus' : 'minus'
                ) : null}

                {settings.answer_required !== 'value_2' || (settings.answer_required === 'value_2' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 4}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'value_2' ? answer : value_2}</text> :
                    utils.getOperationSign(
                        colWidth * 4,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {utils.getOperationSign(
                    colWidth * 5.5,
                    height / 2,
                    fontSize,
                    'equal'
                )}

                {settings.answer_required !== 'answer' || (settings.answer_required === 'answer' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 7}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'answer' ? answer : `${settings.operation === 'addition' ? +value_1 + +value_2 : +value_1 - +value_2}`}</text> :
                    utils.getOperationSign(
                        colWidth * 7,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {settings.answer_required !== 'value_2' || (settings.answer_required === 'value_2' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 9}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'value_2' ? answer : value_2}</text> :
                    utils.getOperationSign(
                        colWidth * 9,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {quantities.value_2 && !isNaN(quantities.value_2) ? utils.getOperationSign(
                    colWidth * 10.5,
                    height / 2,
                    fontSize,
                    settings.operation === 'addition' ? 'plus' : 'minus'
                ) : null}

                {settings.answer_required !== 'value_1' ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 12}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'value_1' ? answer : value_1}</text> :
                    utils.getOperationSign(
                        colWidth * 12,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {utils.getOperationSign(
                    colWidth * 13.5,
                    height / 2,
                    fontSize,
                    'equal'
                )}

                {settings.answer_required !== 'answer' || (settings.answer_required === 'answer' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 15}
                    y={height / 2}
                    textAnchor="middle"
                >{settings.answer_required === 'answer' ? answer : `${settings.operation === 'addition' ? +value_1 + +value_2 : +value_1 - +value_2}`}</text> :
                    utils.getOperationSign(
                        colWidth * 15,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }
            </g>
        )

    } else {

        if ( answerPosition === 'left') {
            numbersLayout = (
                <g>
                    {settings.answer_required !== 'value_1' || (settings.answer_required === 'value_1' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth * 7}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'value_1' ? answer : value_1}</text> :
                        utils.getOperationSign(
                            colWidth * 7,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }

                    {quantities.value_2 && !isNaN(quantities.value_2) ? utils.getOperationSign(
                        colWidth * 5.5,
                        height / 2,
                        fontSize,
                        settings.operation === 'addition' ? 'plus' : 'minus'
                    ) : null}

                    {settings.answer_required !== 'value_2' || (settings.answer_required === 'value_2' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth * 4}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'value_2' ? answer : value_2}</text> :
                        utils.getOperationSign(
                            colWidth * 4,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }

                    {utils.getOperationSign(
                        colWidth * 2.5,
                        height / 2,
                        fontSize,
                        'equal'
                    )}

                    {settings.answer_required !== 'answer' || (settings.answer_required === 'answer' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'answer' ? answer : `${settings.operation === 'addition' ? +value_1 + +value_2 : +value_1 - +value_2}`}</text> :
                        utils.getOperationSign(
                            colWidth,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }
                </g>
            )
        } else {
            numbersLayout = (
                <g>
                    {settings.answer_required !== 'value_1' || (settings.answer_required === 'value_1' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'value_1' ? answer : value_1}</text> :
                        utils.getOperationSign(
                            colWidth,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }

                    {quantities.value_2 && !isNaN(quantities.value_2) ? utils.getOperationSign(
                        colWidth * 2.5,
                        height / 2,
                        fontSize,
                        settings.operation === 'addition' ? 'plus' : 'minus'
                    ) : null}

                    {settings.answer_required !== 'value_2' || (settings.answer_required === 'value_2' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth * 4}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'value_2' ? answer : value_2}</text> :
                        utils.getOperationSign(
                            colWidth * 4,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }

                    {utils.getOperationSign(
                        colWidth * 5.5,
                        height / 2,
                        fontSize,
                        'equal'
                    )}

                    {settings.answer_required !== 'answer' || (settings.answer_required === 'answer' && answer !== '?') ? <text
                        className="level-text-primary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={colWidth * 7}
                        y={height / 2}
                        textAnchor="middle"
                    >{settings.answer_required === 'answer' ? answer : `${settings.operation === 'addition' ? +value_1 + +value_2 : +value_1 - +value_2}`}</text> :
                        utils.getOperationSign(
                            colWidth * 7,
                            height / 2,
                            fontSize,
                            'answer'
                        )
                    }
                </g>
            )
        }
    }
    return (
        <svg
            height={height}
            width={width}
        >
            {numbersLayout}
        </svg>
    )
}

function getNumberString(settings, quantities, answer) {

    const operation = settings.operation
    let operationSymbol = operation === 'addition' ? '+' : '-'

    quantities.value_3 = quantities.value_3 ? quantities.value_3 : 0
    const values = getValues(Math.abs(quantities.value_1), Math.abs(quantities.value_2), Math.abs(quantities.value_3), answer, settings)
    const answerPosition = settings.answer_position && settings.answer_position === 'left' ? 'left' : 'right'
    const commutative = settings.commutative
    let numbersString = ''
    if (settings.question) {
        numbersString = parser.parseQuestion(settings.question, quantities, answer)
    } else {
        if (commutative) {
            numbersString = `${values[0]} ${operationSymbol} ${values[1]} = ${values[1]} ${operationSymbol} ${values[0]} = ${values[3]}`
        } else {
            if (answerPosition === 'right') {
                numbersString = `${values[0]} ${operationSymbol} ${values[1]}` + (values[2] ? ` ${operationSymbol} ${values[2]} ` : '') + ` = ${values[3]}`
            } else {
                numbersString = `${values[3]} = ${values[0]} ${operationSymbol} ${values[1]}` + (values[2] ? ` ${operationSymbol} ${values[2]} ` : '')
            }
        }
    }

    return numbersString
}

function getNumberBridgeString(settings, quantities, answer, operations) {

    const operation = settings.operation
    let operationSymbol1 = operation === 'addition' ? '+' : '-'
    let operationSymbol2 = operation === 'addition' ? '+' : '-'
    if (operations) {
        operationSymbol1 = operations.operation_1 || operationSymbol1
        operationSymbol2 = operations.operation_2 || operationSymbol2
    }
    quantities.value_3 = quantities.value_3 ? quantities.value_3 : 0
    const values = getValues(Math.abs(quantities.value_1), Math.abs(quantities.value_2), Math.abs(quantities.value_3), answer, settings)
    const commutative = settings.commutative
    let numbersString = ''
    if (commutative) {
        numbersString = `${values[0]} ${operationSymbol1} ${values[1]} = ${values[1]} ${operationSymbol1} ${values[0]} = ${values[3]}`
    } else {
        numbersString = `${values[0]} ${operationSymbol1} ${values[1]}` + (values[2] ? ` ${operationSymbol2} ${values[2]} ` : '') + ` = ${values[3]}`
    }
    return numbersString
}

function getNumberLinesString(settings, answer, steps = null) {

    const operation = settings.operation
    let operationSymbol = operation === 'addition' ? '+' : '-'
    let numbersString = ''
    if (steps && steps instanceof Array) {
        steps.forEach((step, index) => {
            numbersString += ` ${index === 0 ? '' : operationSymbol} ${Math.abs(step)}`
        })
        numbersString += ` = ${answer}`
    }
    return numbersString
}

function getValues(value_1, value_2, value_3, answer, settings) {
    const operation = settings.operation
    const answerRequired = settings.answer_required || 'answer'
    value_3 = value_3 && !isNaN(value_3) ? +value_3 : 0

    if (settings.show_tens) {
        if (operation === 'addition') {
            if (answerRequired === 'value_1') {
                answer = utils.isPowerOfTen(value_1) ? answer + ' tens' : answer
                return [answer, utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'value_2') {
                answer = utils.isPowerOfTen(value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), answer, utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'value_3') {
                answer = utils.isPowerOfTen(value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), answer, utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'answer') {
                answer = utils.isPowerOfTen(value_1 + value_2 + value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), answer]
            } else {
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            }
        } else {
            if (answerRequired === 'value_1') {
                answer = utils.isPowerOfTen(value_1) ? answer + ' tens' : answer
                return [answer, utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'value_2') {
                answer = utils.isPowerOfTen(value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), answer, utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'value_3') {
                answer = utils.isPowerOfTen(value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), answer, utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'answer') {
                answer = utils.isPowerOfTen(value_1 - value_2 - value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), answer]
            } else {
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            }
        }
    } else {
        if (operation === 'addition') {
            if (answerRequired === 'value_1') {
                return [answer, value_2, value_3, value_1 + value_2 + value_3]
            } else if (answerRequired === 'value_2') {
                return [value_1, answer, value_3, value_1 + value_2 + value_3]
            } else if (answerRequired === 'value_3') {
                return [value_1, value_2, answer, value_1 + value_2 + value_3]
            } else if (answerRequired === 'answer') {
                return [value_1, value_2, value_3, answer]
            } else {
                return [value_1, value_2, value_3, value_1 + value_2 + value_3]
            }
        } else {
            if (answerRequired === 'value_1') {
                return [answer, value_2, value_3, value_1 - value_2 - value_3]
            } else if (answerRequired === 'value_2') {
                return [value_1, answer, value_3, value_1 - value_2 - value_3]
            } else if (answerRequired === 'value_3') {
                return [value_1, value_2, answer, value_1 - value_2 - value_3]
            } else if (answerRequired === 'answer') {
                return [value_1, value_2, value_3, answer]
            } else {
                return [value_1, value_2, value_3, value_1 - value_2 - value_3]
            }
        }
    }
}

export default {
    getLevelLayout,
    getNumberString,
    getNumberBridgeString,
    getNumberLinesString,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/number.utils.js